import { computed, Injectable, signal } from "@angular/core";
import { RoleStateModel } from "../Dto/RoleStateModel";
import { RoleListItem } from "../Dto/RoleModel";
import { PaginationInfo } from "../Dto/RoleSearchResponse";
import { SearchRoleRequest } from "../Dto/RoleSearchRequest";

const initialState: RoleStateModel = {
  data: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 1,
  },
  searchParams: {
    page: 1,
    limit: 10,
  },
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class RoleState {
  private readonly state = signal<RoleStateModel>(initialState);

  public readonly data = computed(() => this.state().data);
  public readonly pagination = computed(() => this.state().pagination);
  public readonly searchParams = computed(() => this.state().searchParams);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);

  setRoles(data: RoleListItem[], pagination: PaginationInfo): void {
    this.state.update((state) => ({
      ...state,
      data,
      pagination,
    }));
  }

  setSearchParams(params: SearchRoleRequest): void {
    this.state.update((state) => ({
      ...state,
      searchParams: params,
    }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }

  removeRoleFromState(roleId: string): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.filter((role) => role.id !== roleId),
      pagination: {
        ...state.pagination,
        total: state.pagination.total - 1,
        pages: Math.max(1, Math.ceil((state.pagination.total - 1) / state.pagination.limit)),
      },
    }));
  }
}
